import React from "react";
import { useTranslation } from "react-i18next";

import "../../styles/theme.css";
import "../../styles/dashboard.css";
import "../../styles/ProfilesManager.css";
import "../../styles/helpProfile.css";

export default function Helpmcp() {
  const { t } = useTranslation("help");

  const tableRows = t("helpmcp.table.rows", {
    returnObjects: true,
    defaultValue: [
      {
        control: "Safe-Mode MCP Tests",
        purpose: "Lower-disruption checks for MCP protocol behavior.",
        detail:
          "Use for routine validation. Categories include protocol testing, transport testing, tools discovery, tool semantics, robustness, auth, rate limiting, session cancellation, pagination, resources, prompts handling, observability, side-effect safety, and baseline behavior."
      },
      {
        control: "Test All",
        purpose: "Selects every test in the current mode.",
        detail:
          "Use for broad baseline coverage. Deselect items that are not relevant to the server or that duplicate another control."
      },
      {
        control: "Intrusive-Mode MCP Tests",
        purpose:
          "Higher-impact checks that may stress or disrupt MCP services.",
        detail:
          "Run only in non-production or explicitly approved environments. The UI itself warns that these tests may cause disruption."
      },
      {
        control: "Concurrent Requests",
        purpose:
          "Number of parallel or repeated requests for resource-exhaustion checks.",
        detail:
          "Increase gradually and monitor server CPU, memory, and connection counts."
      },
      {
        control: "Protocol Requests",
        purpose: "Number of protocol-violation or malformed requests.",
        detail:
          "Use to test parser robustness and error handling without crashing the MCP server."
      },
      {
        control: "Tool Requests",
        purpose: "Number of tool-abuse requests.",
        detail:
          "Use for servers with exposed tools. Confirm tools are safe to call repeatedly before enabling high values."
      },
      {
        control: "Number of Attacks",
        purpose:
          "Count for attack families such as data exfiltration, prompt injection, and auth bypass.",
        detail:
          "Start with small counts for smoke tests, then increase for stress or regression coverage."
      }
    ]
  });

  return (
    <div className="theme-whbl">
      {/* Header */}

      <div className="container-fluid">
        <div className="row">
          <main
            style={{
              width: "97%",
              overflowX: "auto"
            }}
          >
            <div className="dashboard">
              {/* Page Header */}
              <div className="pm-header">
                <div className="pm-title-section">
                  <h1 className="pm-title">
                    {t("helpmcp.title", "MCP Attack Surface Profile")}
                  </h1>
                </div>
              </div>

              {/* ========================= */}
              {/* MCP Profile Help Content */}
              {/* ========================= */}

              {/* Step 1 */}
              <div>
                <p>
                  {t(
                    "helpmcp.description",
                    "Use this profile type when the endpoint is an MCP server. WhiteHaX separates safer protocol/robustness checks from intrusive checks that may disrupt services."
                  )}
                </p>

                <br />
                <br />
                <div>
                  <img     className="help-img"   src={t("helpmcp.image")}      />
                  <br />
                  <br />

                  <img
                    className="help-img"
                    src={t("helpmcp.image2")}

                  />
                  <br />
                  <br />
                  <img     className="help-img"   src={t("helpmcp.image3")}      />
<br/><br/>

                  <img     className="help-img"   src={t("helpmcp.image4")}     />
                </div>

                <br />
                <br />
                <table className="dark-guide-table">
                  <thead>
                    <tr>
                      <th>
                        {t("helpmcp.table.headers.control", "Control")}
                      </th>
                      <th>
                        {t("helpmcp.table.headers.purpose", "Purpose")}
                      </th>
                      <th>
                        {t(
                          "helpmcp.table.headers.detail",
                          "User-guide detail"
                        )}
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {(Array.isArray(tableRows) ? tableRows : []).map(
                      (row, index) => (
                        <tr key={index}>
                          <td>{row.control}</td>
                          <td>{row.purpose}</td>
                          <td>{row.detail}</td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>

                <style>{`
                  .dark-guide-table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: fixed;
                    font-family: "Segoe UI", Arial, sans-serif;
                    font-size: 14px;
                    color: #e5e7eb;
                    background: #111827;
                    border: 1px solid #374151;
                  }

                  .dark-guide-table thead th {
                    background: #1f2937;
                    color: #60a5fa;
                    font-weight: 700;
                    text-align: left;
                    padding: 12px 14px;
                    border: 1px solid #4b5563;
                    vertical-align: middle;
                  }

                  .dark-guide-table tbody td {
                    background: #111827;
                    color: #e5e7eb;
                    padding: 12px 14px;
                    border: 1px solid #374151;
                    vertical-align: top;
                    line-height: 1.55;
                  }

                  .dark-guide-table tbody tr:nth-child(even) td {
                    background: #172033;
                  }

                  .dark-guide-table tbody tr:hover td {
                    background: #1e293b;
                  }

                  .dark-guide-table th:nth-child(1),
                  .dark-guide-table td:nth-child(1) {
                    width: 23%;
                  }

                  .dark-guide-table th:nth-child(2),
                  .dark-guide-table td:nth-child(2) {
                    width: 30%;
                  }

                  .dark-guide-table th:nth-child(3),
                  .dark-guide-table td:nth-child(3) {
                    width: 47%;
                  }

                  @media (max-width: 768px) {
                    .dark-guide-table {
                      min-width: 750px;
                    }
                  }
                `}</style>
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
}